import { render, staticRenderFns } from "./TrainingType.vue?vue&type=template&id=726020b0"
import script from "./TrainingType.vue?vue&type=script&lang=ts"
export * from "./TrainingType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports